<template>
    <div>
        <h5>{{ $t('account.update_account') }}</h5>

        <form @submit.prevent="submitForm">
            <ValidationObserver v-slot="{ invalid, dirty }" ref="formRef">
                <ValidationProvider :name="$t('account.update.name')" vid="name" rules="required" v-slot="{ errors }" class="flex-grow-1">
                    <div class="form-group row">
                        <label class="form-control-label col-4">{{ $t('account.update.name') }}*</label>
                        <div class="col-8">
                            <input
                                :disabled="isLoading"
                                type="text"
                                class="form-control form-control-sm"
                                v-model="formValues.name"
                                :class="{ 'is-invalid': errors.length }"
                            />

                            <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                        </div>
                    </div>
                </ValidationProvider>

                <ValidationProvider :name="$t('account.update.email')" vid="email" rules="required|email" v-slot="{ errors }" class="flex-grow-1">
                    <div class="form-group row">
                        <label class="form-control-label col-4">{{ $t('account.update.email') }}*</label>
                        <div class="col-8">
                            <input
                                :disabled="isLoading"
                                type="email"
                                class="form-control form-control-sm"
                                v-model="formValues.email"
                                :class="{ 'is-invalid': errors.length }"
                            />

                            <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                        </div>
                    </div>
                </ValidationProvider>

                <ValidationProvider :name="$t('account.update.phone')" vid="phone" v-slot="{ errors }" class="flex-grow-1">
                    <div class="form-group row">
                        <label class="form-control-label col-4">{{ $t('account.update.phone') }}</label>
                        <div class="col-8">
                            <input
                                :disabled="isLoading"
                                type="tel"
                                class="form-control form-control-sm"
                                v-model="formValues.phone"
                                :class="{ 'is-invalid': errors.length }"
                            />

                            <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                        </div>
                    </div>
                </ValidationProvider>

                <button class="btn btn-primary btn-sm" type="submit" :disabled="invalid || !dirty">{{ $t('account.update.submit') }}</button>
            </ValidationObserver>
        </form>
    </div>
</template>

<script setup>
    import { ref, watch } from 'vue';
    import { ValidationObserver, ValidationProvider } from 'vee-validate';

    const emit = defineEmits(['submit']);

    const props = defineProps({
        isLoading: {
            type: Boolean,
            default: false,
        },

        defaultValues: {
            type: Object,
            default: null,
        },

        errors: {
            type: Array,
            default: null,
        },
    });

    const formRef = ref(null);
    const formValues = ref({
        name: props.defaultValues?.name,
        email: props.defaultValues?.email,
        phone: props.defaultValues?.phone,
    });

    watch(() => props.errors, () => {
        formRef.value.setErrors(props.errors);
    });

    function submitForm() {
        emit('submit', formValues.value);
    }
</script>
